import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'

import { hot } from 'react-hot-loader'
import React from 'react'
import { Provider } from "react-redux";
import store from './redux/store'
import PageRouter from './containers/PageRouter'

import './css/style_dark.css'

const App = () =>
  <Provider store={store}>
    <PageRouter/>
  </Provider>

export default hot(module)(App)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/App.js